export default async function product({ handle }) {
  let res;
  let json;
  try {
    res = await fetch(`/products/${handle}.json`, {});

    if (res.ok) {
      json = await res.json();
      return { success: true, res, data: json, error: null };
    }

    // All other statuses
    throw new Error('There was a problem adding to cart');
  } catch (error) {
    return {
      success: false,
      res,
      data: null,
      // Aliasing message to description here to match how shopify returns error messages
      error: { ...error, description: error.message },
    };
  }
}
